export default [
    {
        name: 'event_type',
        hideLabel: true,
        component: {
            type: 'v-select',
            props: {
                label: 'Event type',
                dense: true,
                clearable: true,
                smallChips: true,
                multiple: true,
                hideSelected: true,
                deletableChips: true
            }
        }
    },
    {
        name: 'account_id',
        hideLabel: true,
        component: {
            type: 'v-text-field',
            props: {
                label: 'Account Id',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'device_id',
        hideLabel: true,
        component: {
            type: 'v-text-field',
            props: {
                label: 'Device Id',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'timestampStart',
        hideLabel: true,
        component: {
            type: 'date-select',
            props: {
                label: 'Start date'
            }
        }
    },
    {
        name: 'timestampEnd',
        hideLabel: true,
        component: {
            type: 'date-select',
            props: {
                label: 'End date'
            }
        }
    }
];
